import { Stack, Text } from "@mantine/core"
import { InfoBox } from "@tfg/ui"

import type { ValidationErrorIssueDto } from "~/gen/api"

interface BulkUpdateErrorsSummaryProps {
  readonly validationErrors: readonly ValidationErrorIssueDto[]
}

export const BulkUpdateErrorsSummary = ({
  validationErrors,
}: BulkUpdateErrorsSummaryProps) => {
  if (validationErrors.length === 0) {
    return null
  }

  return (
    <InfoBox
      variant="error"
      title="Errors found"
      message={
        <Stack gap={4} mah={300} style={{ overflowY: "auto" }}>
          {validationErrors.map((error: ValidationErrorIssueDto) => (
            <Text fz="xs" key={error.unicityKey}>
              {error.type === "invalidHeader"
                ? `Invalid headers: ${error.message}`
                : `Error: Row ${error.rowNumber} - ${error.message} ${error.unicityKey ? ` - ${error.unicityKey}` : ""}`}
            </Text>
          ))}
        </Stack>
      }
    />
  )
}
